// extracted by mini-css-extract-plugin
export default {"container":"cards-block_container__3OVfm","title":"cards-block_title__1wo6g","sponsor":"cards-block_sponsor__14lgk","sponsorImage":"cards-block_sponsorImage__3oMS2"};